/* G5 — keep the "You've viewed X of Y products" counter and its bar current as
   load-more appends.

   Madrid's load-more.js is jQuery and fires no event we can listen for. It does append
   into a known container (`.load-more-grid`, see assets/load-more.js line 63), so this
   observes that container instead of patching it — no core edit to the JS.

   Counts the DOM rather than keeping a running total: forloop.index restarts on every
   batch, and Madrid re-renders the grid wholesale when a filter changes, so anything
   incremental drifts.

   If a Madrid update moves the append target, this stops updating but the
   server-rendered initial numbers stay correct — degrades quietly, does not break. */

(function () {
  'use strict';

  /* FILTERS REPLACE THE GRID (Serena, 13 Sep 2026: "it says I am only viewing 32
     of 62"). Applying a filter or a sort makes facets.js swap the whole grid and
     this counter for new elements, so an observer bound to the original
     `.load-more-grid` went on watching a detached node: Load More appended the
     remaining products but the counter stayed at 32 and the button disappeared,
     which reads as nothing having loaded.

     So everything is looked up again on every update, and the observer sits on
     `#ProductGridContainer`, which facets.js keeps and only refills. */
  var container = document.getElementById('ProductGridContainer') || document.body;

  function update() {
    var root = document.querySelector('[data-stl-progress]');
    var grid = document.querySelector('.load-more-grid');
    if (!root || !grid) return;

    var shownEl = root.querySelector('[data-stl-progress-shown]');
    var fillEl = root.querySelector('[data-stl-progress-fill]');
    var total = parseInt(root.getAttribute('data-stl-progress-total'), 10);
    if (!shownEl || !fillEl || !total || total < 1) return;

    /* Editorial tiles are <li>s in the same grid, so count cards specifically. */
    var shown = grid.querySelectorAll('.collection-product-card').length;
    if (shown > total) shown = total;

    if (shownEl.textContent !== String(shown)) shownEl.textContent = shown;
    fillEl.style.width = ((shown / total) * 100) + '%';
  }

  var pending = false;

  new MutationObserver(function (mutations) {
    /* Only additions of elements matter — card sliders mutate attributes and
       text constantly. A single append fires many mutations; coalesce them.
       setTimeout, not requestAnimationFrame: rAF is suspended while the tab is
       hidden, so a load-more in a backgrounded tab would leave the counter stale
       until the tab was focused again. Timers keep running. */
    if (pending) return;
    var added = mutations.some(function (m) { return m.addedNodes.length; });
    if (!added) return;
    pending = true;

    setTimeout(function () {
      pending = false;
      update();
    }, 0);
  }).observe(container, { childList: true, subtree: true });

  update();
})();
